import jsCookies from 'js-cookie';
import * as constants from '@/common/constants';
import { get, post, del } from '@/utils/http';
import { getRoutes } from '@/router';
// import routeCustomer from '@/router/modules/route-customer';
// import Layout from '@/pages/Layout';
// import { isEmpty } from 'lodash';

export const fileUpload = () => {
    return post(constants.API_FILE_UPLOAD, { });
};

export const getMenuData = () => {
    return new Promise((resolve, reject) => {
        let routes = getRoutes();
        // console.log(userInfo);
        // console.log(routes);
        resolve(routes);
    });
};
export const login = (username, pwd, webCode, imageCodeKey, passwordErrorCount) => {
    jsCookies.remove('JSESSIONID');
    return new Promise((resolve, reject) => {
        get(constants.API_USER_LOGIN, { input: username, pwd: pwd, webCode: webCode, imageCodeKey: imageCodeKey, passwordErrorCount: passwordErrorCount }).then(res => {
            // console.log(res);
            if (res.jsessionid) {
                jsCookies.set('JSESSIONID', res.jsessionid);
            }
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
};

export const loginPre = (param) => {
    return post(constants.API_USER_LOGIN_PRE, param);
};

export const loginOut = () => {
    return get(constants.API_USER_LOGINOUT, {});
};

export const getCurrentUserInfo = () => {
    return get(constants.API_USER_CURRENT_LOGIN);
};

export const getMyBaseInfo = () => {
    return get(constants.API_USER_GET_MY_BASEINFO);
};

export const getProcessTaskCnt = () => {
    return get(constants.API_WORKBENCH_PROCESS_TASK_CNT);
};
export const getProcessTaskCntNew = () => {
    return get(constants.API_WORKBENCH_PROCESS_TASK_CNT_NEW);
};
export const getApprovalCnt = () => {
    return get(constants.API_WORKBENCH_APPROVAL_CNT);
};

export const createAndGetPreviewPdf = (param) => {
    return post(constants.API_PDF_CREATE_AND_PREVIEW, param);
};

export const getIsCanApproval = (param) => {
    return post(constants.API_APPROVAL_IS_CAN_APPROVAL, param);
};

// 消息中心
export const getMessageList = (params = { currentPage: 1, pageSize: 10 }) => {
    return get(constants.API_MESSAGE_CENTER_LIST, params);
};

export const updMessage = (message) => {
    return post(constants.API_MESSAGE_CENTER_UPDATE, message);
};

export const updAllMessageStatus = (message) => {
    return post(constants.API_MESSAGE_CENTER_ALL_MESSAGE_STATUS_UPDATE, message);
};

export const deleteMessage = (msgId) => {
    return del(constants.API_MESSAGE_CENTER_DELETE.replace(':msgId', msgId));
};

export const delAllMessage = (message) => {
    return post(constants.API_MESSAGE_CENTER_ALL_MESSAGE_DELETE, message);
};

export const getMessage = (msgId) => {
    return get(constants.API_MESSAGE_CENTER_GETMESSAGE.replace(':msgId', msgId));
};

export const getCompanyMessageTemplateList = (currentPage = 1, pageSize = 10, keyWord) => {
    return get(constants.API_COMPANY_MESSAGE_TEMPLATE_LIST, { currentPage, pageSize, msgTemplateTitle: keyWord });
};

export const getCompanyMsgReceiverInList = (currentPage = 1, pageSize = 10, msgTemplateId, keyWord) => {
    return get(constants.API_COMPANY_MESSAGE_TEMPLATE_RECEIVER_IN_LIST, { currentPage, pageSize, msgTemplateId: msgTemplateId, trueName: keyWord });
};

export const getCompanyMsgReceiverNotInList = (currentPage = 1, pageSize = 10, msgTemplateId, keyWord) => {
    return get(constants.API_COMPANY_MESSAGE_TEMPLATE_RECEIVER_NOTIN_LIST, { currentPage, pageSize, msgTemplateId: msgTemplateId, trueName: keyWord });
};

export const delMsgReceiver = (id) => {
    return del(constants.API_COMPANY_MESSAGE_TEMPLATE_RECEIVER_DELETE.replace(':id', id));
};

export const saveMultMsgReceiver = (msgTemplateReceiver) => {
    return post(constants.API_COMPANY_MESSAGE_TEMPLATE_RECEIVER_SAVA, msgTemplateReceiver);
};

export const getWarnMessageList = (params = { currentPage: 1, pageSize: 10 }) => {
    return get(constants.API_MESSAGE_WARN_LIST, params);
};

export const getSMSForForgetPwd = (user) => {
    return post(constants.API_LOGIN_FORGET_PWD_SEND_SMS, user);
};

export const updUserPwdForReset = (user) => {
    return post(constants.API_LOGIN_FORGET_PWD_UPD_PWD, user);
};

export const getCreateImageCodeKey = (imageCodeKey) => {
    return get(constants.API_LOGIN_CREATE_IMAGE_CODE_KEY);
};

export const sendUrgeMessage = (message) => {
    return post(constants.API_MESSAGE_CENTER_URGE_MESSAGE_ADD, message);
};

export const getUrgeMessageByMeList = (currentPage = 1, pageSize = 10, msgType, status) => {
    return get(constants.API_MESSAGE_CENTER_URGE_MESSAGE_SEND_LIST, { currentPage, pageSize, msgType: msgType, status: status });
};

export const delUrgeMessage = (message) => {
    return post(constants.API_MESSAGE_CENTER_URGE_MESSAGE_DELETE, message);
};

// processState的BI数据
export const getTotalInfoForBI = (busiType) => {
    return get(constants.API_OPERATION_PROCESS_TOTEL_INFO.replace(':busiType', busiType));
};
// export const getProcessInfoForBI = (busiTypes, state) => {
//     return get(constants.API_OPERATION_PROCESS_INFO.replace(':busiTypes', busiTypes).replace(':state', state));
// };
export const getProcessInfoForBI = (param) => {
    return post(constants.API_OPERATION_PROCESS_INFO, param);
};
// 员工状态
export const getUserRealtimeState = (param) => {
    return post(constants.API_OPERATION_USER_REAL_TIME_STATE, param);
};

export const getUserRealtimeDetailState = (userId) => {
    return get(constants.API_OPERATION_USER_REAL_TIME_DETAIL_STATE.replace(':userId', userId));
};

// 用户注册发送验证码
export const getSMSForRegister = (user) => {
    return post(constants.API_LOGIN_REGISTER_SEND_SMS, user);
};

// 甘特图
export const getTimeGantt = (processInstanceId) => {
    return get(constants.API_OPERATION_TIME_GANTT.replace(':processInstanceId', processInstanceId));
};
export const getTimeGanttForCompare = (processInstanceId) => {
    return get(constants.API_OPERATION_TIME_GANTT_FOR_COMPARE.replace(':processInstanceId', processInstanceId));
};

export const getPlanTimeGantt = (processInstanceId) => {
    return get(constants.API_OPERATION_PLAN_TIME_GANTT.replace(':processInstanceId', processInstanceId));
};

// 闭环BI
export const getProcessListForCloseBI = (param) => {
    return post(constants.API_OPERATION_PROCESS_CLOSE_PROCESS_LIST, param);
};

export const getProcessDetailForCloseBI = (param) => {
    return post(constants.API_OPERATION_PROCESS_CLOSE_PROCESS_DETAIL, param);
};

// 审批流BI
export const getApproveInstancesStateList = (busiType) => {
    return get(constants.API_OPERATION_APPROVAL_STATE_LIST.replace(':busiType', busiType));
};

export const getApprovalProcessInfoForBI = (param) => {
    return post(constants.API_OPERATION_APPROVAL_STATE_INFO_LIST, param);
};

// 审批效率BI
export const getApprovalTimeRatio = (param) => {
    return post(constants.API_OPERATION_APPROVAL_TIME_RATIO, param);
};

// 流程实例BI
export const getBcbpmProcessInstanceBICnt = (param) => {
    return post(constants.API_OPERATION_BCBPM_PROCESS_INSTNCE_BI, param);
};

// 企业登录信息BI
export const getLoginInfoListBIByTenantId = (param) => {
    return post(constants.API_OPERATION_BCBPM_LOGIN_INFO_LIST_BI, param);
};

// 项目管理分布
export const getProcessTimeTreeList = (param) => {
    return post(constants.API_OPERATION_PROCESS_TIME_TREE_LIST, param);
};

// 查看所有流程
export const getAllProcessInstanceList = (param) => {
    return post(constants.API_OPERATION_ALL_PROCESS_INSTANCE_LIST, param);
};

export const getProcessAdjTreeList = (param) => {
    return post(constants.API_OPERATION_PROCESS_ADJ_TREE_LIST, param);
};

export const getProcessCacheDataById = (param) => {
    return post(constants.API_OPERATION_PROCESS_CACHE_DATA_BY_ID, param);
};

export const upgradeSysApply = (resourceVersion) => {
    return post(constants.API_USER_UPGRADE_APPLY, {resourceVersion: resourceVersion});
};

export const changeSwitchLayoutFlg = (userId, switchLayoutFlg) => {
    return post(constants.API_USER_SWITCHLAYOUTFLG, {userId: userId, switchLayoutFlg: switchLayoutFlg});
};

export const getUserRemindNum = () => {
    return post(constants.API_MENU_USER_REMIND_NUM);
};

export const getAboutMeTotalNum = () => {
    return post(constants.API_ABOUT_ME_TOTAL_NUM);
};

export const changePortalMode = (param) => {
    return post(constants.API_USER_PORTALMODE, param);
};

// 新版流程实例树查询
export const getProcessInstanceTreeList = (param) => {
    return post(constants.API_PROCESS_INSTANCE_TREE_LIST, param);
};

// 新版流程实例树子节点懒加载
export const getProcessInstanceTreeChildren = (param) => {
    return post(constants.API_PROCESS_INSTANCE_TREE_CHILDREN, param);
};

export const getLoginInfoList = (params) => {
    return get(constants.API_OPERATION_GET_LOGIN_INFO_LIST, params);
};

export const getUserLoginInfoList = (params) => {
    return get(constants.API_OPERATION_GET_USER_LOGIN_INFO_LIST, params);
};

export const getMenuProcessTreeList = (param) => {
    return post(constants.API_PROCESS_TASK_PROCESS_TREE_LIST, param);
};

export const getAuthenticationUserInfo = (param) => {
    return get(constants.API_GET_AUTHENTICATION_USER_INFO, param);
};



// WEBPACK FOOTER //
// ./src/data-model/base/base-model.js